<template>
    <tr>
        <td>
          {{item.macAddress}}
        </td>
        <td>
          {{item.action === "RELEASE" ? "LIBERADO" : "BLOQUEADO"}}
        </td>       

        <td class="edit">
            <v-icon size="20"
                    slot="activator"
                    v-tooltip="$t('message.generics.message.edit')"
                    @click="edit">mdi-pencil</v-icon>
        
            <v-icon size="20"
                    slot="activator"
                    v-tooltip="$t('message.generics.message.remove')"
                    @click="remove">mdi-delete</v-icon>

        </td>
        <app-confirmation-modal :value="!!pendingRemove"
                                :confirm-label="$t('message.generics.message.confirm')"
                                @confirm="confirmRemove"
                                @cancel="cancelRemove">
          <span slot="heading">
            {{$t('message.generics.message.exclude')}}
          </span>
          <span>
            {{$t('message.generics.message.confirmExclusion')}}
          </span>
        </app-confirmation-modal>
    </tr>
</template>

<script>
    import AppConfirmationModal from '@components/ConfirmationModal'
    import EventBus from '@packages/event-bus/index'
    export default {
        components: {
            AppConfirmationModal
        },

        props: {
            dataItem: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                pendingRemove: null
            }
        },

        computed: {
            item() {
                return this.dataItem
            },

        },

        methods:{
            remove() {
              this.pendingRemove = this.item.macAddress;
            },
            async confirmRemove() {
                await this.$api.macAddresses.remove(this.item.macAddress)
                this.pendingRemove = null
                this.$emit("deleted")
                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: "Endereço MAC deletado com sucesso"
                });
            },
            cancelRemove(){
                this.pendingRemove = null
            },
            edit() {
                EventBus.$emit('EDIT_ITEM', this.item)
            }

        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.edit {
  .mdi {
    font-size: 18px;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}
.icon-green {
  color: $primary;
}
</style>
